export default {
  "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["bonjour i18n !!"])}
}